import React, { useState, useEffect } from 'react';
import Wrapper from '../../Main/Universal/Wrapper';
import { formatDate2, postAPI } from '../../../app/api';
import Swal from 'sweetalert2';
import editIcon from "../../../theme/assets/images/icon/edit-icon.svg"
import deleteIcon from "../../../theme/assets/images/icon/delete-icon.svg"

export default function PendingSubscriptions() {
  const [members, setMembers] = useState([]);

  const [loading, setLoading] = useState(false);

  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const [showViewModal, setShowViewModal] = useState(false);

  const [viewMember, setViewMember] = useState(null);

  const [selectedMember, setSelectedMember] = useState(null);

  const [paymentData, setPaymentData] = useState({
    membership_type: 'annual',
    membership_amount: 10000,
    payment_mode: 'CASH',
    invoice_number: '',
    receipt_number: '',
    submission_status: 'PAID'
  });



  // Handle payment form changes
  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Generate unique invoice number
  // const generateInvoiceNumber = () => {
  //     const date = new Date();
  //     const year = date.getFullYear().toString().slice(2);
  //     const month = String(date.getMonth() + 1).padStart(2, '0');
  //     const day = String(date.getDate()).padStart(2, '0');
  //     const random = Math.floor(1000 + Math.random() * 9000);
  //     return `INV${year}${month}${day}${random}`;
  // };

  const generateUniqueId = (prefix, user_code) => {
    let ISO = new Date().toISOString().split('T')[0]
    let serial_no = Math.floor(1000 + Math.random() * 9000); // 4 digit random number
    let timestamp = ISO.split('-')
    let date = timestamp[2]
    let month = parseInt(timestamp[1])
    let year = timestamp[0].slice(2)
    // Combine prefix, timestamp, and random number to create the unique ID
    const userId = `${prefix}${user_code}${date}${String.fromCharCode(64 + month)}${serial_no}${year}`;

    return userId;
  }

  // Open payment form for member
  const handleOpenPaymentForm = (member) => {
    setSelectedMember(member);
    setPaymentData({
      membership_type: 'annual',
      membership_amount: 10000,
      payment_mode: 'CASH',
      invoice_number: generateUniqueId('I', member.user_code),
      receipt_number: '',
      submission_status: 'PAID'
    });
    setShowPaymentForm(true);
  };

  // Submit payment
  const handleSubmitPayment = async (e) => {
    e.preventDefault();
    try {
      if (!paymentData.invoice_number || !paymentData.membership_amount) {
        Swal.fire('Validation', 'Please fill all required fields', 'warning');
        return;
      }

      // Calculate membership dates
      const startDate = new Date();
      let endDate = new Date();

      if (paymentData.membership_type === 'lifetime') {
        endDate.setFullYear(endDate.getFullYear() + 100); // Life membership
      } else {
        endDate.setFullYear(endDate.getFullYear() + 1); // Annual membership
      }

      // Create transaction
      const transactionPayload = {
        module: 'MEMBERSHIP',
        user_code: selectedMember.user_code,
        invoice_number: paymentData.invoice_number,
        invoice_no: paymentData.invoice_number,
        receipt_number: paymentData.receipt_number || paymentData.invoice_number,
        currency: 'INR',
        amount: paymentData.membership_amount,
        membership_amount: paymentData.membership_amount,
        payment_amount: paymentData.membership_amount,
        gateway: paymentData.payment_mode === 'CASH' ? 'CASH' : paymentData.payment_mode === 'CHECK' ? 'CHECK' : 'ONLINE',
        mode: paymentData.payment_mode,
        submission_status: paymentData.submission_status,
        payment_payload: {
          member_name: `${selectedMember.first_name} ${selectedMember.last_name}`,
          email: selectedMember.email_id,
          phone: selectedMember.mobile_number,
          membership_type: paymentData.membership_type
        },
        orderData: {
          reference_number: paymentData.reference_number
        }
      };

      const transactionResponse = await postAPI('finance/create', transactionPayload);

      if (transactionResponse?.status === 1) {
        Swal.fire('Success', 'Payment recorded successfully', 'success');
        setShowPaymentForm(false);
        setSelectedMember(null);
        fetchMembers();
      } else {
        Swal.fire('Error', transactionResponse?.msg || 'Failed to create transaction', 'error');
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      Swal.fire('Error', error.message || 'Failed to process payment', 'error');
    }
  };


  // Fetch all members
  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      setLoading(true);
      const response = await postAPI('finance/list', {});
      if (response?.status === 1) {
        setMembers(response?.data || []);
      }
    } catch (error) {
      console.error('Error fetching members:', error);
      Swal.fire('Error', 'Failed to fetch members', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Handle view member details
  const handleView = (member) => {
    setViewMember(member);
    setShowViewModal(true);
  };
  return (
    <Wrapper>
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Pending Subscriptions</h3>
              {/* <button
                className="btn btn-primary"
                onClick={handleToggleForm}
              >
                {showForm ? 'Cancel' : 'Add New Member'}
              </button> */}
            </div>
          </div>
        </div>

        {/* Payment Modal */}
        <div className={`modal fade ${showPaymentForm ? "show d-block modal-white" : ""}`} tabIndex="-1" style={{ background: showPaymentForm ? "rgba(0,0,0,0.5)" : "transparent" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Record Payment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPaymentForm(false)}
                ></button>
              </div>

              <div className="modal-body">
                {selectedMember && (
                  <div className="mb-3">
                    <strong>Member:</strong> {selectedMember.first_name} {selectedMember.last_name}
                    <br />
                    <strong>Email:</strong> {selectedMember.email_id}
                  </div>
                )}

                <form onSubmit={handleSubmitPayment}>
                  <div className="mb-3">
                    <label className="form-label">Membership Type *</label>
                    <select
                      className="form-control"
                      name="membership_type"
                      value={paymentData.membership_type}
                      onChange={handlePaymentChange}
                      required
                    >
                      <option value="lifetime">Life Membership</option>
                      <option value="annual">Annual Membership</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Payment Mode *</label>
                    <select
                      className="form-control"
                      name="payment_mode"
                      value={paymentData.payment_mode}
                      onChange={handlePaymentChange}
                      required
                    >
                      <option value="CASH">Cash</option>
                      <option value="CHECK">Check</option>
                      {/* <option value="ONLINE">Online</option> */}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      {paymentData.payment_mode == 'CASH' ? 'Memo No *' : 'Cheque Number *'}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="reference_number"
                      value={paymentData.reference_number}
                      onChange={handlePaymentChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Membership Amount *</label>
                    <input
                      type="number"
                      className="form-control"
                      name="membership_amount"
                      value={paymentData.membership_amount}
                      onChange={handlePaymentChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Invoice Number *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="invoice_number"
                      value={paymentData.invoice_number}
                      // onChange={handlePaymentChange}
                      required
                      disabled
                    />
                  </div>

                  {/* <div className="mb-3">
                                            <label className="form-label">Receipt Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="receipt_number"
                                                value={paymentData.receipt_number}
                                                onChange={handlePaymentChange}
                                                placeholder="Optional"
                                            />
                                        </div> */}

                  <div className="mb-3">
                    <label className="form-label">Payment Status *</label>
                    <select
                      className="form-control"
                      name="submission_status"
                      value={paymentData.submission_status}
                      onChange={handlePaymentChange}
                      required
                    >
                      <option value="PAID">Paid</option>
                      <option value="PENDING">Pending</option>
                      <option value="FAILED">Failed</option>
                    </select>
                  </div>
                  <button type="submit" className="btn btn-success w-100">
                    Record Payment
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-hover cus-table">
                  <thead className="table-dark">
                    <tr>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Email Id</th>
                      <th>Phone</th>
                      <th>Discipline</th>
                      <th>Approve Member</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members && members.length > 0 ? (
                      members.map((member, index) => !member?.membership_id ? (
                        <tr key={index}>
                          <td>
                            {member.image ? (
                              <img src={member.image} alt="Profile" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: '50%' }} />
                            ) : (
                              <span style={{ width: 48, height: 48, display: 'inline-block', background: '#eee', borderRadius: '50%' }} />
                            )}
                          </td>
                          <td>{member.first_name} {member.middle_name} {member.last_name}</td>
                          <td>{member.email_id}</td>
                          <td>{member.mobile_number}</td>
                          <td>{member.discipline || '-'}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={async () => {
                                const result = await Swal.fire({
                                  title: 'Approve Member',
                                  text: `Are you sure you want to approve ${member.first_name} ${member.last_name}?`,
                                  icon: 'question',
                                  showCancelButton: true,
                                  confirmButtonText: 'Approve',
                                  cancelButtonText: 'Cancel'
                                });
                                if (result.isConfirmed) {
                                  try {
                                    const response = await postAPI('authentication/users/approve', { user_code: member.user_code, approved_by: 'admin' });
                                    if (response?.status === 1) {
                                      Swal.fire('Success', 'Member approved successfully', 'success');
                                      fetchMembers();
                                    } else {
                                      Swal.fire('Error', response?.msg || 'Failed to approve member', 'error');
                                    }
                                  } catch (error) {
                                    Swal.fire('Error', 'Failed to approve member', 'error');
                                  }
                                }
                              }}
                            >
                              Approve
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary me-2 px-1 py-1 my-0 mx-0"
                              onClick={() => handleView(member)}
                              title="View Details"
                            >
                              <i className={'fa fa-eye'} alt="View Details" />
                            </button>
                            <button
                              className="btn btn-sm btn-success me-2 px-1 py-1 my-0 mx-0"
                              onClick={() => handleOpenPaymentForm(member)}
                              title="Record Payment"
                            >
                              💰
                            </button>
                          </td>
                        </tr>
                      ) : <></>)
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          No members found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* View Member Details Modal */}
        <div className={`modal fade ${showViewModal ? "show d-block modal-white" : ""}`} tabIndex="-1" style={{ background: showViewModal ? "rgba(0,0,0,0.5)" : "transparent" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Member Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowViewModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {viewMember && (
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <h6 className="text-muted">Personal Information</h6>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{ width: '40%' }}>Name</th>
                            <td>{viewMember.first_name} {viewMember.middle_name} {viewMember.last_name}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{viewMember.email_id || '-'}</td>
                          </tr>
                          <tr>
                            <th>Mobile</th>
                            <td>{viewMember.mobile_number || '-'}</td>
                          </tr>
                          <tr>
                            <th>Date of Birth</th>
                            {
                              viewMember.date_of_birth != 'Invalid date' ?
                                <td>{viewMember.date_of_birth ? formatDate2(viewMember.date_of_birth)?.month + ' ' + formatDate2(viewMember.date_of_birth)?.day + ', ' + formatDate2(viewMember.date_of_birth)?.year : '-'}</td>
                                : <></>
                            }
                          </tr>
                          <tr>
                            <th>Designation</th>
                            <td>{viewMember.designation || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-md-6 mb-3">
                      <h6 className="text-muted">Academic Information</h6>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{ width: '40%' }}>Discipline</th>
                            <td>{viewMember.discipline || '-'}</td>
                          </tr>
                          <tr>
                            <th>Passing Year</th>
                            <td>{viewMember.passing_year || '-'}</td>
                          </tr>
                          <tr>
                            <th>Introduced By</th>
                            <td>{viewMember.introduce_by || '-'}</td>
                          </tr>
                          <tr>
                            <th>Introducer Year</th>
                            <td>{viewMember.introduce_passing_year || '-'}</td>
                          </tr>
                          <tr>
                            <th>Introducer Discipline</th>
                            <td>{viewMember.introduce_discipline || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-md-12 mb-3">
                      <h6 className="text-muted">Address Information</h6>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{ width: '20%' }}>Postal Address</th>
                            <td>{viewMember.postal_address || '-'}</td>
                          </tr>
                          <tr>
                            <th>State</th>
                            <td>{viewMember.state || '-'}</td>
                          </tr>
                          <tr>
                            <th>Country</th>
                            <td>{viewMember.country || '-'}</td>
                          </tr>
                          <tr>
                            <th>Pin Code</th>
                            <td>{viewMember.pin_code || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-md-12 mb-3">
                      <h6 className="text-muted">Family Information</h6>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{ width: '20%' }}>Spouse Name</th>
                            <td>{viewMember.spouse_name || '-'}</td>
                          </tr>
                          <tr>
                            <th>Spouse Date of Birth</th>
                            {
                              viewMember.dob_of_spouse != 'Invalid date' ?
                                <td>{viewMember.dob_of_spouse ? formatDate2(viewMember.dob_of_spouse)?.month + ' ' + formatDate2(viewMember.dob_of_spouse)?.day + ', ' + formatDate2(viewMember.dob_of_spouse)?.year : '-'}</td>
                                : <></>
                            }
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-md-12 mb-3">
                      <h6 className="text-muted">Membership Status</h6>
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{ width: '20%' }}>Status</th>
                            <td>
                              <span className={`badge badge-${viewMember.status === 1 ? 'success' : 'danger'}`}>
                                {viewMember.status === 1 ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th>Membership</th>
                            <td>
                              <span className="badge badge-warning">
                                No Membership Yet
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowViewModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setShowViewModal(false);
                    handleOpenPaymentForm(viewMember);
                  }}
                >
                  Record Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

